import { KAZAKHSTAN_REGION_ID } from '../const';

export const isKazakhstanRegion = (regionId: string) => regionId === KAZAKHSTAN_REGION_ID;
